import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import { useRef } from 'react';

function ServerStatus({ serverStatus, setPopupStyle }) {
  const apiUrl = process.env.REACT_APP_API_DOMAIN + `yeonoo/monitoring/server/status/detail?serverStatus=${serverStatus}`;
  console.log(serverStatus);
  console.log(apiUrl);
  const dataSource = {
    api: {
      readData: { url: apiUrl, method: 'GET' }
    }
  };

  const columnArray = [
    { name: 'name', header: '서버', align: 'center', width: 80 },
    { name: 'receive_time', header: '수신 시각', align: 'center', width: 130 },
    { name: 'memo', header: '메모', align: 'center', width: 300, whiteSpace: 'normal' }
  ];
  const gridReference = useRef(); // 그리드 참조
  
  const grid = (
    <Grid
      ref={gridReference} //그리드 참조
      width={'100%'}
      bodyHeight={'auto'}
      rowHeight={'auto'}
      data={dataSource}
      columns={columnArray}
      rowHeaders={['rowNum']}
      onResponse={OnResponse} //서버 응답
      onGridUpdated={OnGridUpdated}
    />
  );

  function OnGridUpdated(event) {
    let allColumnWidth = 0;
    const tempColumnArray = [...columnArray];
    const columns = gridReference.current.getInstance().getColumns();
    for (const index1 in columns) {
      for (const index2 in tempColumnArray) {
        if (tempColumnArray[index2].name === columns[index1].name) {
          if (columns[index1].autoResizing === true) {
            //컬럼 사이즈가 오토로 지정됐다면 width에 + 10하여 셀 내용 잘림 방지
            tempColumnArray[index2].width = columns[index1].baseWidth + 10;
          }
          
          //그리드의 width를 정하기 위해 총 컬럼 width를 구함
          allColumnWidth += tempColumnArray[index2].width;
        }
      }
    }
    event.instance.setColumns(tempColumnArray);

    setPopupStyle((previousState) => {
      const previousStyle = {...previousState};
      
      const height = gridReference.current.getInstance().getRowCount() * 40 + 104;
      const maxHeight = window.innerHeight * 0.8;
      const minHeight = 217;
      if (height >= maxHeight) {
        previousStyle.content.height = maxHeight;
      } else if (height >= minHeight) {
        previousStyle.content.height = height;
      } else {
        previousStyle.content.height = minHeight;
      }
      
      //그리드 height 적용, 두 코드 모두 사용 가능
      event.instance.setBodyHeight(previousStyle.content.height - (87));
      //event.instance.setHeight(previousStyle.content.height - (46));

      const width = allColumnWidth + 61;
      const maxWidth = window.innerWidth * 0.9;
      if (width >= maxWidth) {
        previousStyle.content.width = maxWidth;
      } else {
        previousStyle.content.width = width;  
      }

      return previousStyle;
    });
  }

  function OnResponse(event) {
    const response = JSON.parse(event.xhr.response);

    if (!response.result) {
      alert(`(${response.apiUrl}) ${response.apiMethod} API 실패\n${response.message}`);
    }
  }

  return grid;
}

export default ServerStatus;